import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import useCurrentUser from '../../../hooks/useCurrentUser';
import UserAvatar from './UserAvatar';
import { Header, Dropdown } from '../styles';
import { IHeaderMenuProps } from '../types';
import PageMenuParceiro from "./PageMenuParceiro";

const HeaderMenu: React.FC<IHeaderMenuProps> = (props: IHeaderMenuProps) => {
  const {
    onSignOutButtonClick,
    collapsed,
    toggle,
    onModalStatus,
  } = props;
  const { name } = useCurrentUser();
  return (
    <Header>
      {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
        className: 'trigger',
        onClick: toggle,
      })}
      <div className='pages'><PageMenuParceiro /></div>
      <UserAvatar
        userName={name}
        onSignOutButtonClick={onSignOutButtonClick}
        onModalStatus={onModalStatus}
      />
    </Header>
  );
};

export default HeaderMenu;
